var Vue = require('vue');
var SubscriptionForm = require('./components/SubscriptionForm').default;

module.exports = function () {
    if (document.getElementById('payment-subscription-form')) {
        new Vue({
            el: '#payment-subscription-form',
            components: {
                'subscriptionForm': SubscriptionForm
            }
        });
    }
};
